module.exports = __webpack_public_path__ + "img/cartoons_anime.66d1a63a.png";